/* lmm-pdp-seo.js — Copy-Buttons (Art.-Nr.) + USP-Kachel-Toggle für die PDP.
   Vanilla JS, keine Abhängigkeiten. Ergänzt lmm-pdp.js (Galerie/Menge/Sticky)
   und lmm-pdp-inline.js (Energielabel-Modal/Kelvin/Rechner/Check/Subtotal).

   Hinweis: Der frühere Ersparnis-Rechner ([data-lmm-calc]) und der alte
   Kompatibilitäts-Check ([data-lmm-check]) wurden hier entfernt — beide hingen an
   inzwischen umbenannten Attributen (aktiv ist [data-lmm-calc-vat] bzw.
   [data-lmm-check-v2] in lmm-pdp-inline.js) und waren damit toter Code. */
(function () {
  'use strict';

  /* ---------- Copy-Buttons: Artikelnummer in die Zwischenablage ---------- */
  document.querySelectorAll('[data-lmm-copy]').forEach(function (btn) {
    var value = btn.dataset.lmmCopy;
    var label = btn.querySelector('[data-lmm-copy-label]');
    var original = label ? label.textContent : '';
    var timer = null;

    btn.addEventListener('click', function () {
      var done = function () {
        btn.classList.add('is-copied');
        if (label) label.textContent = 'Kopiert';
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (label) label.textContent = original;
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(done, function () {});
      } else {
        /* Fallback für ältere Browser/unsichere Kontexte */
        var ta = document.createElement('textarea');
        ta.value = value;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  });

  /* ---------- USP-Kacheln: aufklappbare Kurzerklärungen ----------
     Desktop: Hover (nur echte Maus, pointerType-Guard gegen Touch-Emulation)
     und Tastatur-Fokus (:focus-visible) öffnen; Klick/Tap toggelt überall.
     Es ist immer nur eine Kachel gleichzeitig offen. */
  var usps = document.querySelector('[data-lmm-benefits]');
  if (usps) {
    var tiles = Array.prototype.slice.call(usps.querySelectorAll('.lmm-benefit'));
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

    var setOpen = function (tile, open) {
      var btn = tile.querySelector('.lmm-benefit__btn');
      if (!btn) return;
      if (open) {
        tiles.forEach(function (other) {
          if (other !== tile) setOpen(other, false);
        });
      }
      tile.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    var isOpen = function (tile) { return tile.classList.contains('is-open'); };

    tiles.forEach(function (tile) {
      var btn = tile.querySelector('.lmm-benefit__btn');
      if (!btn) return;

      /* Tap (Touch) und Enter/Space (Tastatur) toggeln. Echte Maus-Klicks auf
         hover-fähigen Geräten toggeln NICHT — dort öffnet/schließt der Hover;
         sonst würde ein Klick die gerade per Hover geöffnete Kachel sofort
         wieder schließen. Fallback für Browser ohne PointerEvent-Click:
         detail === 0 kennzeichnet Tastatur-Aktivierung. */
      btn.addEventListener('click', function (e) {
        var pt = e.pointerType !== undefined
          ? e.pointerType
          : (e.detail === 0 ? 'keyboard' : 'mouse');
        if (hoverable.matches && pt === 'mouse') return;
        setOpen(tile, !isOpen(tile));
      });

      /* Hover nur auf hover-fähigen Geräten mit echter Maus */
      tile.addEventListener('pointerenter', function (e) {
        if (hoverable.matches && e.pointerType === 'mouse') setOpen(tile, true);
      });
      tile.addEventListener('pointerleave', function (e) {
        if (hoverable.matches && e.pointerType === 'mouse') setOpen(tile, false);
      });

      /* Tastatur: sichtbarer Fokus öffnet (wie Hover) … */
      btn.addEventListener('focusin', function () {
        var focusVisible = false;
        try { focusVisible = btn.matches(':focus-visible'); } catch (err) {}
        if (focusVisible && !isOpen(tile)) setOpen(tile, true);
      });
      /* … und Fokus, der die Kachel verlässt, schließt wieder */
      tile.addEventListener('focusout', function (e) {
        if (!tile.contains(e.relatedTarget)) setOpen(tile, false);
      });
    });
  }

  /* ---------- Röhren-Länge in den kompakten Übersichten ----------
     Bei Röhren ist für die Auswahl die Länge ohne Sockelstifte maßgeblich.
     Quelle ist die kanonische Tabellenzeile aus specs.length_without_pins_mm.
     Die ausführliche technische Tabelle zeigt weiterhin beide Maße. */
  (function () {
    var glance = document.querySelector('.lmm-glance');
    var heroTiles = document.querySelectorAll('.lmm-tiles .lmm-tile');
    if (!glance && !heroTiles.length) return;

    var normalizeLabel = function (text) {
      return String(text || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    };

    var lengthWithoutPins = '';
    Array.prototype.some.call(
      document.querySelectorAll('#lmm-technische-daten .lmm-specgroup tr'),
      function (row) {
        var key = row.querySelector('th');
        var value = row.querySelector('td');
        if (!key || !value || normalizeLabel(key.textContent) !== 'länge ohne sockelstifte') return false;
        lengthWithoutPins = String(value.textContent || '')
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        return true;
      }
    );

    if (lengthWithoutPins) {
      lengthWithoutPins = lengthWithoutPins.replace(/(\d)[,.]0(?=\s*mm\b)/i, '$1');

      if (glance) {
        Array.prototype.some.call(glance.querySelectorAll('dl > div'), function (row) {
          var key = row.querySelector('dt');
          var value = row.querySelector('dd');
          if (!key || !value || normalizeLabel(key.textContent) !== 'länge') return false;
          value.textContent = lengthWithoutPins;
          return true;
        });
      }

      Array.prototype.forEach.call(heroTiles, function (tile) {
        var key = tile.querySelector('.lmm-tile__k');
        var value = tile.querySelector('.lmm-tile__v');
        if (!key || !value || normalizeLabel(key.textContent) !== 'länge') return;
        value.textContent = lengthWithoutPins;
      });
    }

    if (!glance) return;

    /* Der Seitenkasten bleibt unter dem Sticky-Header UND der oberen Kaufleiste.
       Mobil ist er ohnehin nicht sticky. */
    var setGlanceTop = function () {
      if (!window.matchMedia('(min-width: 990px)').matches) {
        glance.style.removeProperty('top');
        return;
      }
      var rootStyle = window.getComputedStyle(document.documentElement);
      var headerHeight = parseFloat(rootStyle.getPropertyValue('--lmmh-stickyh')) || 0;
      var stickyBar = document.querySelector('[data-lmm-sticky-bar]');
      var stickyHeight = stickyBar ? stickyBar.offsetHeight : 0;
      var stickyTop = stickyBar ? parseFloat(window.getComputedStyle(stickyBar).top) : NaN;
      if (!isFinite(stickyTop)) stickyTop = headerHeight;
      glance.style.top = Math.ceil(stickyTop + stickyHeight + 12) + 'px';
    };

    setGlanceTop();
    window.addEventListener('load', setGlanceTop);
    window.addEventListener('resize', setGlanceTop, { passive: true });
    window.setTimeout(setGlanceTop, 250);

    var stickyBar = document.querySelector('[data-lmm-sticky-bar]');
    if (stickyBar && 'MutationObserver' in window) {
      new MutationObserver(setGlanceTop).observe(stickyBar, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  })();
})();
